export default {
  text: '#202020',
  primary: '#792434',
  secondary: 'grey',
  background: '#fdfdfd',
  backgroundSecondary: 'lightgrey',
  light: '#fdfdfd',
  dark: '#202020'
}
